/**
 * JoinENSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait JoinENSiteHeaderLanguages
 */

import { useJoinENSiteHeaderLanguagesLogic } from '@/hooks/traits/useJoinENSiteHeaderLanguagesLogic';
import type { JoinENSiteHeaderLanguagesConfig } from '@/hooks/traits/useJoinENSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { JoinENJoinView as JoinENJoinViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface JoinENSiteHeaderLanguagesViewProps {
  config?: Partial<JoinENSiteHeaderLanguagesConfig>;
}

export function JoinENSiteHeaderLanguagesView({ config: propsConfig }: JoinENSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useJoinENSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['JoinENJoinView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="JoinEN" trait="JoinENSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu trigger={<Button icon="globe" size="sm" variant="ghost" label={String(__locale.toUpperCase())} />} items={Array.isArray(([{ label: "English" as const, href: "/join" as const, code: "en" as const }, { label: "العربية" as const, href: "/ar/join" as const, code: "ar" as const }, { href: "/sl/join" as const, label: "Slovenščina" as const, code: "sl" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) ? (((([{ label: "English" as const, href: "/join" as const, code: "en" as const }, { label: "العربية" as const, href: "/ar/join" as const, code: "ar" as const }, { href: "/sl/join" as const, label: "Slovenščina" as const, code: "sl" as const }]).map((entry) => ({ id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} position="bottom-end" className={((([{ href: "/join" as const, code: "en" as const, label: "English" as const }, { code: "ar" as const, label: "العربية" as const, href: "/ar/join" as const }, { href: "/sl/join" as const, code: "sl" as const, label: "Slovenščina" as const }]).length === 0)) ? "hidden" : ""} />) : null}
    </TraitScopeProvider>
  );
}

export default JoinENSiteHeaderLanguagesView;
